module.exports = __webpack_public_path__ + "static/media/img14.7277dfe7.jpeg";